"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = exports.buildUrl = void 0;
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
function buildUrl(url, params) {
    if (!params) {
        return url;
    }
    var parts = (0, lodash_1.default)(params)
        .map(function (value, key) {
        if (lodash_1.default.isNil(value)) {
            return '';
        }
        if (lodash_1.default.isDate(value) && !isNaN(value.valueOf())) {
            value = value.toISOString();
        }
        else if (lodash_1.default.isObject(value)) {
            value = JSON.stringify(value);
        }
        return "".concat(encode(key), "=").concat(encode(value));
    })
        .compact()
        .value();
    if (parts.length !== 0) {
        url += (lodash_1.default.includes(url, '?') ? '&' : '?') + parts.join('&');
    }
    return url;
}
exports.buildUrl = buildUrl;
function encode(value) {
    return encodeURIComponent(value)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%20/gi, '+');
}
exports.encode = encode;
//# sourceMappingURL=build-url.js.map